import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _LoanLine } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: (value: any) => void;
    label?: string;
    returnType?: "ID" | "Object";
}

export const LoanLineSelect = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {

    const { instance } = useDataBean(_LoanLine);
    const [lista, setLista] = useState<any[]>([]);
    const [id, setID] = useState<number | null>(null);

    useEffect(() => {
        setID(idSelector);
    }, [idSelector]);

    useEffect(() => {
        getLista();
    }, []);

    const getLista = () => {
        let data = _single.getSessionItem("LoanLineCatalog");
        if (data) {
            setLista(JSON.parse(data));
        } else {
            instance.getLoanLineCatalog(null).then(
                (resp) => {
                    setLista(resp);
                    _single.setSessionItem("LoanLineCatalog", JSON.stringify(resp));
                }
            ).catch(
                err => { console.error("Error al cargar líneas de crédito:", err); }
            );
        }
    };

    const setValue = (e: any) => {
        const selectedID = parseInt(e);
        setID(selectedID);

        if (returnType === "Object") {
            const selectedItem = lista.find(
                (item: any) => item.DataBeanProperties.IDLoanLine === selectedID
            );
            onChange(selectedItem?.DataBeanProperties ?? null);
        } else {
            onChange(selectedID);
        }
    };

    return (
        <>
            <label>{label ?? "Línea de Crédito"}</label>
            <select className="form-select" value={id ?? ""} onChange={(e) => setValue(e.target.value)}>
                <option value={""}>...</option>
                {lista.map((item: any, index: number) => (
                    <option key={index} value={item.DataBeanProperties.IDLoanLine}>
                        {item.DataBeanProperties.Name}
                    </option>
                ))}
            </select>
        </>
    );
};
